<template>
    <div id="footer-model">
        <div class="footer-content">
            <section class="footer-mian-content">
                <router-link to="/recommendList" @click.native="handleClick"><img style="width: 10.1875rem;;" src="../assets/images/logo_bg.png"></router-link>
                <div class="menu-navigat">
                    <i :class="[ismenu ? 'el-icon-close icon-close-color' : 'el-icon-s-fold','menu-fold']" @click="handelChageMenu"></i>
                    <div :class="['menu-list', ismenu ? 'menu-fixed' : '']">
                        <ul>
                            <li><router-link to="/about">
                                <span>ABOUT</span>
                                <span style="margin-left: 3px;">简介</span>
                            </router-link></li>
                            <li><router-link to="/projectList" @click.native="handleClickPrject">
                                <span>PROJECTS</span>
                                <span style="margin-left: 3px;">项目</span>
                            </router-link></li>
                            <li><router-link to="/newsList" @click.native="handleClickNew">
                                <span>EVENTS</span>
                                <span style="margin-left: 3px;">事件</span>
                            </router-link></li>
                            <li><router-link to="/contect">
                                <span>CONTACT</span>
                                <span style="margin-left: 3px;">联系</span>
                            </router-link></li>
                        </ul>
                    </div>
                </div>
            </section>

            

        </div>
        <div class="footer-submenu">
            <ul>
                <li @click="handleJumprojectList(1)"><strong>High-rise Buildings</strong><span>高层建筑</span></li>
                <li @click="handleJumprojectList(2)"><strong>Public Architecture</strong><span>公共建筑</span></li>
                <li @click="handleJumprojectList(3)"><strong>Hotel Architecture</strong><span>酒店建筑</span></li>
                <li @click="handleJumprojectList(4)"><strong>Micro Architecture</strong><span>微型建筑</span></li>
                <!-- <li @click="handleJumprojectList(4)"><strong>Urban Renewal</strong><span>城市更新</span></li> -->
            </ul>
        </div>
        <div class="footer-end-conten">
            <div class="footer-end-center">
                <div style="width: calc(100% - 600px);">
                    <div style="height: 76px;">
                        <div class="en-address">F10, No.68, Huacheng Ave., Zhujiang New Town, Guangzhou, China</div>
                        <div class="cn-address">中国 广州市花城大道68号环球都会广场10楼</div>
                    </div>
                    <div class="filing-ICP"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备 2025383852</a></div>
                    <div>For copyright infringement claims, please contact the administrator at: gz@citygroup.com.cn</div>
                    <div>版权侵权事宜，请联系管理员：gz@citygroup.com.cn</div>
                </div>
                <div class="follow-QR-code">
                    <ul>
                        <li>
                            <a href='https://www.facebook.com/people/CTG/61588263814671' target="_blank"><img src="../assets/images/Facebook.jpg" /></a>
                            <p>FACEBOOK</p>
                        </li>
                        <li>
                            <a href='https://www.instagram.com/ctg_designcenter?utm_source=qr' target="_blank"><img src="../assets/images/Instagram.png" /></a>
                            <p>INSTAGRAM</p>
                        </li>
                        <li>
                            <a href='https://xhslink.com/m/3hYxExkFGmx' target="_blank"><img src="../assets/images/Red_Book.png" /></a>
                            <p>CTG 小红书</p>
                        </li>
                        <li>
                            <img src="../assets/images/WeChat.png" />
                            <p>CTG 微信公众号</p>
                        </li>
                        <li>
                            <img src="../assets/images/Channel.png" />
                            <p>CTG 视频号</p>
                        </li>
                        
                    </ul>
                </div>
                <!-- <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="16" :lg="18" :xl="20">
                        <div>F10, NO.68, HUACHENG AVE., ZHUJIANG NEW TOWN, GUANGZHOU, CHINA   中国 广州市花城大道68号环球都会广场10楼     TEL: +86  17724480482</div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                        <div style="text-align: right;"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025383852</a></div>
                    </el-col>
                </el-row> -->
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data () {
        return {
            ismenu: false,
        }
    },
    methods: {
        handleClick (event) {
            // alert(this.$route.name)
            sessionStorage.removeItem('projectList')
            sessionStorage.removeItem('isCache')
            sessionStorage.removeItem('videolist')

            sessionStorage.removeItem('RecomListData')
            sessionStorage.removeItem('isRecomListCache')

            

            if (this.$route.name === 'RecommendList') {
                event.preventDefault()
                window.location.reload()  
            }
        },

        handleClickPrject (event) {
            sessionStorage.removeItem('ProjectListData')
            sessionStorage.removeItem('isProjectListCache')
            if (this.$route.name === 'ProjectList') {
                event.preventDefault()
                window.location.reload()
            }
            
        },

        handleClickNew (event) {
            sessionStorage.removeItem('ProjectListData')
            sessionStorage.removeItem('isProjectListCache')
            if (this.$route.name === 'NewsList') {
                event.preventDefault()
                window.location.reload()
            }
        },
        // 切换显示菜单
        handelChageMenu () {
            this.ismenu = !this.ismenu
            if (this.ismenu) {
                this.isChildeNavigat = true
            } else {
                this.isChildeNavigat = false
            }
            
            // this.ismenu = true
        },

        handleJumprojectList(type){
            this.$router.push({
                path: '/projectList',
                query: {type: type}
            })
        }
    }
}
</script>

<style scoped lang="scss">
#footer-model {
    width: 100%;
    background: #fff;
}
#footer-model .menu-fold {
    font-size: 30px;
    cursor: pointer;
    display: none;
}
.footer-content {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E5E6E6;
    box-sizing: border-box;
    height: 100px;
    width: calc(100% - 60px);
    margin: auto;
    margin-top: 30px;
}
.footer-mian-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin: auto;
}
.footer-submenu {
    width: calc(100% - 136px);
    margin: auto;
    padding: 27px 0;
}
.footer-submenu li {
    padding: 10px 0;
    color: #000;
    cursor: pointer;
}
.footer-submenu li:hover {
    color: #000;
}
.footer-submenu li strong {
    font-size: 1.25rem;
    font-family: "ahronbd";
    font-weight: 500;
}
.footer-submenu li span {
    font-family: 'SourceHanSansBOLD';
    font-size: 1.125rem;
    padding-left: 10px;
}
.footer-content .menu-list ul{
    display: flex;
}
.footer-content .menu-list li{
    display: flex;
    flex-direction: row;
    // width: 130px;
    text-align: center;
    padding: 0 8px;
}
.footer-content .menu-list li a {
    display:flex;
    align-items: center;
    // display: inline-block;
    // width: 130px;
    color: #333;
    font-size: 1.5rem;
    font-weight: 700;
    height: 20px;
    line-height: 20px;
    // height: 20px;
    // line-height: 20px;
    font-family: "ahronbd";
    position: relative;
}
.footer-content .menu-list li a span:nth-child(1) {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    position: relative;
    z-index: 8;
    background: #fff;
}
.footer-content .menu-list li a span:nth-child(2) {
    // display: none;
    display: inline-block;
    height: 20px;
    line-height: 16px;
    font-family: 'SourceHanSans';
    font-size: 1.125rem;
    // display: inline-block;
    // width: 100%;
    // position: absolute;
    // top: -3px;
    // left: 0;
    // text-align: center;
    // color: #545454;
    // background: #fff;
    // transition: top 0.5s ease;
    // z-index: 4;
}

// .footer-content .menu-list li a:hover span:nth-child(2) {
//     // display: inline-block;
//     top: -29px;
// }

// .footer-content .menu-list li a:hover span:nth-child(1) {
//     display: none;
// }
// .footer-content .menu-list li a:hover span:nth-child(2) {
//     display: block;
// }
.footer-content .menu-list li a:hover {
    color: #545454;
}
.footer-end-conten {
    width: calc(100% - 60px);
    padding: 20px 0;
    border-top: 1px solid #E5E6E6;
    margin: auto;
}
.footer-end-center {
    width: 100%;
    // width: calc(100% - 60px);
    margin: auto;
    font-family: "SourceHanSans";
    font-size: 14px;
    display: flex;
    justify-content: space-between;

}
.footer-end-center .en-address {
    font-family: "Verlag";
    font-size: 20px;
    color: #545454;
    margin-bottom: 5px;

}
.footer-end-center .cn-address {
    font-family: "SourceHanSans";
    font-size: 18px;
    color: #545454;
}
.follow-QR-code li {
    float: left;
    width: 104px;
    height: 6.104px;
    text-align: center;
    margin-left: 10px;
    // background: red;
}
.follow-QR-code li img {
    width: 104px;
    height: 104px;
}
.follow-QR-code li p {
    text-align: center;
    font-family: "SourceHanSans";
    font-size: 14px;
    color: #545454;
}
.filing-ICP {
    font-family: "SourceHanSans";
    font-size: 14px;
    color: #545454;
}
.filing-ICP a {
    color: #545454;
}
// .footer-end-center a {
//     color: #627482;
// }

@media (max-width: 768px) {
    .footer-mian-content {
        width: calc(100% - 20px)
    }
    
    #footer-model .menu-fold {
        display: block;
    }
    .footer-content .menu-navigat .menu-list {
        display: none;
        transform: translateX(100%); /* 从右向左移动 */
        transition: transform 2s ease; /* 添加过渡效果 */
    }
}

@media only screen and (min-width: 2048px) {
    .footer-content .menu-navigat li a {
        font-size: 1.47rem;
    }
  .footer-content .menu-navigat li a span:nth-child(2) {
    font-size: 1.125rem;
  }
}

@media only screen and (min-width: 2560px) {
    .footer-content .menu-navigat li a {
        font-size: 1.52rem;
    }
    .footer-content .menu-navigat li a span:nth-child(2) {
        font-size: 1.15rem;
    }
}
@media (min-width: 1536px) and (max-width: 1708px) {
    .footer-content .menu-navigat li a {
        font-size: 1.4rem;
    }
    .footer-content .menu-navigat li a span:nth-child(2) {
        font-size: 1.15rem;
    }
}

@media (min-width: 1463px) and (max-width: 1536px) {
    .footer-content .menu-navigat li a {
        font-size: 1.35rem;
    }
    .footer-content .menu-navigat li a span:nth-child(2) {
        // display: none;
        font-size: 1.125rem;
    }
}

@media (min-width: 1360px) and (max-width: 1463px) {
    // .footer-content .menu-navigat li a {
    //     font-size: 1.38rem;
    // }
    // .footer-content .menu-navigat li a span:nth-child(2) {
    //     // display: none;
    //     font-size: 1.125rem;
    // }
    .footer-content .menu-navigat li a {
        font-size: 1.8rem;
    }
    .footer-content .menu-navigat li a span:nth-child(2) {
        // display: none;
        font-size: 1.5rem;
    }
}

@media only screen and (max-width: 1280px) {
    // .footer-content .menu-navigat li a {
    //     font-size: 1.33rem;
    // }
    // .footer-content .menu-navigat li a span:nth-child(2) {
    //     font-size: 1.1rem;
    // }

    .footer-content .menu-navigat li a {
        font-size: 1.7rem;
        // color: red;
    }
    .footer-content .menu-navigat li a span:nth-child(2) {
        font-size: 1.255rem;
    }
    .footer-content .menu-navigat li a span:nth-child(1) {
        line-height: 20px;
    }
}

</style>